import React from 'react';
import './App.css';
import BadJoke from './BadJoke/BadJoke';

function App() {
  return (
    <div className="App">
      <BadJoke />
    </div>
  );
}

export default App;
